import {
  OPEN_CREATE_PRODUCT_MODAL,
  CLEAR_CREATE_PRODUCT_MODAL,
  SET_AFFILIATE_PAGE_TOUR_PENDING,
  CLEAR_AFFILIATE_PAGE_TOUR_PENDING
} from '../actions/product-tour';

export const openCreateProductModalReducer = (state = null, action) => {
  switch (action.type) {
    case OPEN_CREATE_PRODUCT_MODAL:
      return action.payload;
    case CLEAR_CREATE_PRODUCT_MODAL:
      return null;
  }
  return state;
};

/**
 * Reducer terpisah, bukan tambahan case di reducer modal di atas: keduanya dipasang sebagai slice
 * sendiri-sendiri di `reducers/index.jsx`, jadi menggabungkannya akan mengubah bentuk state modal
 * yang sudah dipakai `navigation-top-right` dan `components/menu-empty-tour`.
 *
 * Boolean, bukan payload bebas — satu-satunya pertanyaan yang dijawab state ini adalah "barusan ada
 * handoff dari tur menu affiliate?".
 *
 * @param {boolean} state State sebelumnya; default false (tidak ada handoff).
 * @param {Object} action Action redux.
 * @returns {boolean} True hanya di antara handoff dan akhir tur lanjutan.
 */
export const affiliatePageTourPendingReducer = (state = false, action) => {
  switch (action.type) {
    case SET_AFFILIATE_PAGE_TOUR_PENDING:
      return true;
    case CLEAR_AFFILIATE_PAGE_TOUR_PENDING:
      return false;
  }
  return state;
};
